import { ApexOptions } from "apexcharts";

export const leadStatusesName = [
  "New Lead",
  "Not Qualified",
  "Qualified",
  "Contact Attempted",
  "In Progress",
  "Converted",
  "Closed-Won",
  "Closed-Lost",
];

export const leadSourcesName = [
  "Advertisement",
  "Agent",
  "Call",
  "Chatbot",
  "Email Query",
  "External Referral",
  "X (Twitter)",
  "Facebook",
  "Public Relations",
  "Sales Email",
  "Seminar Partner",
  "Internal Seminar",
  "Web Research",
  "Horizon",
  "Manual",
  "Website",
  "Partner",
];

export const leadSourcesNameColors = [
  "#FF6D00",
  "#D50000",
  "#6200EA",
  "#00C853",
  "#43A047",
  "#00ACC1",
  "#1DA1F2",
  "#1877F2",
  "#00897B",
  "#C51162",
  "#FF8F00",
  "#9C27B0",
  "#546E7A",
  "#3F51B5",
  "#795548",
  "#6488EA",
  "#8BE0AE",
  "#FF5E5E",
  "#8E44AD",
];

export const leadStatusesNameColors = [
  "#BD3D44",
  "#6A1B9A",
  "#FFA447",
  "#1976D2",
  "#00C853",
  "#FF5E5E",
  "#FFD600",
  "#263238",
];

export const leadSourceBreakdownOptions: ApexOptions = {
  chart: {
    id: "lead-source-chart",
    toolbar: {
      show: false,
    },
    type: "bar",
    height: 350,
  },
  plotOptions: {
    bar: {
      distributed: true,
      dataLabels: {
        position: "top",
        orientation: "vertical",
      },
      // borderRadius: 4,
      horizontal: false,
      columnWidth: "50%",
    },
  },
  dataLabels: {
    enabled: true,
    offsetY: -30,
    style: {
      colors: ["#fff"],
      fontWeight: "bold",
    },
    formatter: (val) => `${val}`,
  },
  xaxis: {
    categories: [],
    labels: {
      style: {
        fontSize: "14px",
      },
    },
  },
  yaxis: {
    labels: {
      show: true,

      style: {
        fontSize: "14px",
        colors: ["#333"], // Optional: label color
      },
    },
    title: {
      text: "Lead Count", // Optional: Y-axis title
      style: {
        fontSize: "14px",
        fontWeight: 400,
      },
    },
  },
  colors: leadSourcesNameColors,
  legend: {
    show: false,
  },
  grid: {
    show: false, // remove grid lines
  },
};
